import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private http = inject(HttpClient);
  private url: string;
  private headers = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor() {
    this.url = environment.apiURL;
  }

  newsletter(data: any): Observable<any> {
    return this.http.post(this.url + 'newsletters/', data, this.headers);
  }

  savePcc(data: any): Observable<any> {
    return this.http.post(this.url + 'contact-pcc/', data, this.headers);
  }

  getStates(): Observable<any> {
    return this.http.get('https://s3.amazonaws.com/tracsa.com/states.json', this.headers);
  }

  getMunicipalities(): Observable<any> {
    return this.http.get('https://s3.amazonaws.com/tracsa.com/municipalities.json', this.headers);
  }
}
